module.exports = ".deviceTable thead th p-dtcheckbox { display: none !important;}"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/target_device.component.css
// module id = ./src/app/component/target_device.component.css
// module chunks = main